import { BRAND_PRODUCT_SEARCH_SUGGESTIONS_ENABLED_240516 } from "@faire/web-api/indigofair/settings/BRAND_PRODUCT_SEARCH_SUGGESTIONS_ENABLED_240516";

import {
  assignSetting,
  getSettingValueWithoutAssignment,
} from "@faire/retailer/settings/__internal__/getSetting";

export const getSettingEnableBrandPageSearchSuggestions = (): boolean => {
  return getSettingValueWithoutAssignment(
    BRAND_PRODUCT_SEARCH_SUGGESTIONS_ENABLED_240516,
    false
  );
};

export const assignSettingBrandPageSearchSuggestions = async () => {
  return assignSetting(BRAND_PRODUCT_SEARCH_SUGGESTIONS_ENABLED_240516);
};
